import { kontrol_logo } from '@raas/shared/src/assets/images/image';

export const KontrolLogo = ({ styles }: { styles?: React.CSSProperties }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: '10px',
      paddingRight: '10px',
      ...styles,
    }}
  >
    <img src={kontrol_logo} alt="Kontrol Logo" style={{ maxHeight: '85px' }} />
  </div>
);
